import {FETCH_POLICES, setPoliciesAction} from '../../actions/PoliciesActions';
import {API_CALL_SUCCESS, apiRequest, GET} from '../../actions/ApiCallsActions';
import endpoints from '../../../endpoints';

export default ({dispatch}) => next => async action => {
    next(action);

    const {type, payload} = action;
    switch (type) {
    case FETCH_POLICES: {
        const url = endpoints.businessCustomerPolicies();
        dispatch(apiRequest(url, GET, FETCH_POLICES));
        break;
    }
    case `${FETCH_POLICES} ${API_CALL_SUCCESS}`: {
        const {data} = payload;

        dispatch(setPoliciesAction(data));
        break;
    }
    default:
    }
};
